exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.consume_coupon_tabs[data-v-792dbab3] {\n  padding: 12px;\n}\n", ""]);

// exports
